import { Col, Container, Form, Row } from 'react-bootstrap'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { history } from '../../..'
import { AuctionFilter, FilterModes, FilterModesDate } from '../../../app/models/modes'
import { useStore } from '../../../app/stores/store'
import { useState } from 'react'
import { IconButton } from '@mui/material'

function FavoriteFilter() {
  const { favoriteAuctionsStore } = useStore()
  const { favoriteFilter, setFavoriteFilter, favorites } =
    favoriteAuctionsStore
  const { t } = useTranslation()
  const [title, setTitle] = useState<string>('')

  const navigationLinks = [{ title: t('home'), link: '/' }, { title: t('favorites') }]

  const auctionFilterCheck = [
    { md: 2, title: t('upcoming'), value: AuctionFilter.upcoming },
    { md: 2, title: t('active'), value: AuctionFilter.active },
    { md: 2, title: t('finished'), value: AuctionFilter.finished },
  ]

  const handleInputChangeNumber = (e: any) => {
    const { name, value } = e.target
    if (name === 'type') {
      const isChecked = favoriteFilter.type === parseInt(value)
      setFavoriteFilter({
        ...favoriteFilter,
        [name]: isChecked ? AuctionFilter.none : parseInt(value),
      })
    } else {
      setFavoriteFilter({ ...favoriteFilter, [name]: parseInt(value) })
    }
  }

  const handleSearch = () => {
    setFavoriteFilter({ ...favoriteFilter, title: title })
  }

  const clearSearch = () => {
    setFavoriteFilter({ ...favoriteFilter, title: '' })
    setTitle('')
  }

  return (
    <Container fluid className='navigation-container'>
      <div className='navigation'>
        <div className='navigation-links'>
          {navigationLinks.map((nav, index) => (
            <p
              key={index}
              onClick={() => {
                if (index !== navigationLinks.length - 1) {
                  history.push(nav.link || '')
                }
              }}
              className='navigation-link'
            >
              <span>{nav.title}</span>
            </p>
          ))}
        </div>
        <Container fluid>
          <Row className='align-items-center'>
            <Col className='ps-0'>
              <h1 className='h1-style'>
                {favoriteFilter.category === FilterModes.all
                  ? `All Favorites (${favorites.length})`
                  : favoriteFilter.category === FilterModes.auction
                    ? `${t('favorite_auctions')} (${favorites.length})`
                    : `${t('favorite_posts')} (${favorites.length})`}
              </h1>
            </Col>
            <Col>
              <Row className='align-items-end'>
                <Col md={9} className='favorite-search-input pe-0'>
                  <p className='paragraph-style'>{t('search_fav')}</p>
                  <div className='position-relative'>
                    <Form.Control
                      className='card-input-style'
                      placeholder={t('enter_title')!}
                      type='text'
                      name='title'
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                      required
                    />
                    {title && (
                      <div className='position-absolute top-50 end-0 translate-middle'>
                        <IconButton onClick={clearSearch}>
                          <i className='fa-solid fa-xmark' />
                        </IconButton>
                      </div>
                    )}
                  </div>
                </Col>
                <Col className='pe-0' md={3}>
                  <div className='favorite-search mt-2'>
                    <button onClick={handleSearch}>{t('search')}</button>
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <Container fluid className='navigation-filters'>
          <Row className='align-items-end'>
            <Col md={3} className='filter-buttons mb-3 mb-md-0'>
              <p>{t('category')}</p>
              <Form.Select
                defaultValue={favoriteFilter.category}
                name='category'
                onChange={handleInputChangeNumber}
              >
                <option value={FilterModes.all}>{t('all')}</option>
                <option value={FilterModes.auction}>{t('auction')}</option>
                <option value={FilterModes.post}>{t('post')}</option>
              </Form.Select>
            </Col>
            <Col md={3} className='filter-buttons mb-3 mb-md-0'>
              <p>{t('sorting')}</p>
              <Form.Select
                defaultValue={favoriteFilter.sorting}
                name='sorting'
                onChange={handleInputChangeNumber}
              >
                <option value={FilterModesDate.all}>{t('all')}</option>
                <option value={FilterModesDate.newest}>{t('newest')}</option>
                <option value={FilterModesDate.oldest}>{t('oldest')}</option>
              </Form.Select>
            </Col>
            {auctionFilterCheck.map((filter, index) => (
              <Col
                md={filter.md}
                key={index}
                className='filter-buttons mb-3 mb-md-0 filter-checkbox-col'
              >
                <Form.Group className='d-flex gap-content text-black filter-checkbox'>
                  <label
                    style={{
                      opacity: favoriteFilter.category === FilterModes.auction ? 1 : 0.5,
                    }}
                    className='d-flex gap-2 align-items-center'
                  >
                    <Form.Check
                      type='checkbox'
                      className='text-black mb-0'
                      onChange={handleInputChangeNumber}
                      value={filter.value}
                      name='type'
                      checked={
                        favoriteFilter.category === FilterModes.auction
                          ? favoriteFilter.type === filter.value
                          : false
                      }
                      disabled={favoriteFilter.category !== FilterModes.auction}
                    />
                    {filter.title}
                  </label>
                </Form.Group>
              </Col>
            ))}
          </Row>
        </Container>
      </div>
    </Container>
  )
}
export default observer(FavoriteFilter)
